(() => {
'use strict';
const d = document;
const w = window;
const root = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
const reduce = w.matchMedia('(prefers-reduced-motion: reduce)');
const small = w.matchMedia('(max-width: 699px)');
const $ = (s, el = d) => el.querySelector(s);
const $$ = (s, el = d) => Array.from(el.querySelectorAll(s));
const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
const rand = (a, b) => a + Math.random() * (b - a);
const smooth = (e0, e1, x) => {
const t = clamp((x - e0) / (e1 - e0), 0, 1);
return t * t * (3 - 2 * t);
};
const SECTION = 'va-cart-drawer';
const conn = navigator.connection;
const lowData = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));
const weatherOn = () => !reduce.matches && !d.body.classList.contains('va-still');
const sprites = {};
const sprite = (soft) => {
if (sprites[soft]) return sprites[soft];
const c = d.createElement('canvas');
c.width = c.height = 64;
const g = c.getContext('2d');
const grd = g.createRadialGradient(32, 32, 0, 32, 32, 32);
const core = [0.5, 0.3, 0.08][soft];
grd.addColorStop(0, 'rgba(255,251,244,1)');
grd.addColorStop(core, 'rgba(255,251,244,.92)');
grd.addColorStop(Math.min(0.98, core + 0.42), 'rgba(255,251,244,.28)');
grd.addColorStop(1, 'rgba(255,251,244,0)');
g.fillStyle = grd;
g.fillRect(0, 0, 64, 64);
sprites[soft] = c;
return c;
};
const weathers = [];
const makeWeather = (canvas) => {
const mode = canvas.dataset.weather;
const ctx = canvas.getContext && canvas.getContext('2d');
if (!ctx || !/^(snow|rain|dust)$/.test(mode)) return null;
let W = 0;
let H = 0;
let parts = [];
let on = false;
let raf = 0;
let last = 0;
let t = rand(0, 100);
const spawn = (p, anywhere) => {
if (mode === 'snow') {
const z = Math.pow(Math.random(), 2.1);
p.z = z;
p.r = 0.7 + z * z * 8;
p.vy = 24 + z * 150 + rand(-6, 6);
p.sw = rand(0.4, 1.3);
p.ph = rand(0, 6.283);
p.amp = 5 + z * 28;
p.a = z < 0.5 ? 0.42 + z * 0.96 : 0.9 - (z - 0.5) * 1.1;
p.soft = z > 0.6 ? 2 : z > 0.28 ? 1 : 0;
p.x = rand(-60, W + 60);
p.y = anywhere ? rand(-20, H) : rand(-80, -10);
} else if (mode === 'rain') {
const z = Math.pow(Math.random(), 1.6);
p.z = z;
p.len = 12 + z * 50;
p.vy = 950 + z * 950;
p.b = z > 0.66 ? 2 : z > 0.33 ? 1 : 0;
p.x = rand(-80, W + 40);
p.y = anywhere ? rand(-60, H) : rand(-160, -20);
} else {
p.r = rand(0.5, 1.7);
p.vx = rand(-5, 5);
p.vy = rand(-3, 5);
p.a0 = rand(0.18, 0.75);
p.tw = rand(0.4, 1.4);
p.ph = rand(0, 6.283);
p.x = rand(0, W);
p.y = rand(0, H);
}
return p;
};
const target = () => {
const area = W * H;
if (mode === 'snow') return Math.round(Math.min(420, 70 + area / 5200));
if (mode === 'rain') return Math.round(Math.min(380, 60 + area / 4200));
return Math.round(Math.min(90, 18 + area / 9000));
};
const resize = () => {
const r = canvas.getBoundingClientRect();
const dpr = Math.min(w.devicePixelRatio || 1, 1.5);
W = Math.max(1, r.width);
H = Math.max(1, r.height);
canvas.width = Math.round(W * dpr);
canvas.height = Math.round(H * dpr);
ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
const n = target();
while (parts.length < n) parts.push(spawn({}, true));
parts.length = n;
};
const rainStyles = [
[0.7, 'rgba(214,224,236,.13)'],
[1.1, 'rgba(214,224,236,.2)'],
[1.8, 'rgba(214,224,236,.16)']
];
const draw = (dt) => {
ctx.clearRect(0, 0, W, H);
if (mode === 'snow') {
const wind = 16 + Math.sin(t * 0.17) * 20 + Math.sin(t * 0.61 + 1.3) * 9;
for (const p of parts) {
p.y += p.vy * dt;
p.x += (wind * (0.25 + p.z) + Math.cos(t * p.sw + p.ph) * p.amp * 0.7) * dt;
if (p.y > H + 20 || p.x > W + 80 || p.x < -80) spawn(p, false);
const s = (p.r + (p.soft === 2 ? p.r * 0.9 : p.soft ? 1 : 0.6)) * 2;
ctx.globalAlpha = p.a;
ctx.drawImage(sprite(p.soft), p.x - s / 2, p.y - s / 2, s, s);
}
ctx.globalAlpha = 1;
} else if (mode === 'rain') {
const slant = 0.16 + Math.sin(t * 0.33) * 0.05;
for (let b = 0; b < 3; b++) {
ctx.lineWidth = rainStyles[b][0];
ctx.strokeStyle = rainStyles[b][1];
ctx.beginPath();
for (const p of parts) {
if (p.b !== b) continue;
p.y += p.vy * dt;
p.x += p.vy * slant * dt;
if (p.y - p.len > H || p.x > W + 80) spawn(p, false);
ctx.moveTo(p.x, p.y);
ctx.lineTo(p.x - slant * p.len, p.y - p.len);
}
ctx.stroke();
}
} else {
const img = sprite(0);
for (const p of parts) {
p.x += (p.vx + Math.sin(t * 0.3 + p.ph) * 4) * dt;
p.y += (p.vy + Math.cos(t * 0.23 + p.ph) * 3) * dt;
if (p.x < -4) p.x = W + 4;
if (p.x > W + 4) p.x = -4;
if (p.y < -4) p.y = H + 4;
if (p.y > H + 4) p.y = -4;
ctx.globalAlpha = p.a0 * (0.5 + 0.5 * Math.sin(t * p.tw + p.ph));
const s = p.r * 3;
ctx.drawImage(img, p.x - s / 2, p.y - s / 2, s, s);
}
ctx.globalAlpha = 1;
}
};
const frame = (now) => {
if (!on) return;
const dt = Math.min(0.05, (now - last) / 1000 || 0.016);
last = now;
t += dt;
draw(dt);
raf = requestAnimationFrame(frame);
};
const api = {
canvas,
active(v) {
v = !!v && weatherOn();
if (v === on) return;
on = v;
if (on) {
resize();
last = performance.now();
raf = requestAnimationFrame(frame);
} else cancelAnimationFrame(raf);
},
resize() {
if (on) resize();
}
};
weathers.push(api);
return api;
};
const ro = 'ResizeObserver' in w ? new ResizeObserver((entries) => entries.forEach((e) => weathers.forEach((x) => x.canvas === e.target && x.resize()))) : null;
const watchSize = (api) => api && ro && ro.observe(api.canvas);
const films = [];
const io = 'IntersectionObserver' in w
? new IntersectionObserver((entries) => {
entries.forEach((e) => {
const f = films.find((x) => x.el === e.target);
if (!f) return;
f.visible = e.isIntersecting;
f.sync();
});
}, { rootMargin: '120px 0px' })
: null;
const initFilms = (scope) => {
$$('[data-film]', scope).forEach((el) => {
if (el.__va) return;
el.__va = true;
const host = el.closest('[data-film-scope]') || el.parentElement;
const f = {
el,
video: $('video', el),
weather: null,
toggle: $('[data-film-toggle]', host),
visible: !io,
paused: reduce.matches || lowData
};
const cv = $('canvas[data-weather]', el);
if (cv) {
f.weather = makeWeather(cv);
watchSize(f.weather);
}
if (f.video) {
f.video.muted = true;
f.video.addEventListener('playing', () => el.classList.add('is-playing'));
} else if (f.toggle && !f.weather) f.toggle.hidden = true;
f.sync = () => {
const run = f.visible && !f.paused && !d.hidden;
const v = f.video;
if (v) {
if (run) {
const src = (small.matches && v.dataset.srcM) || v.dataset.src;
if (src && v.dataset.cur !== src) {
v.dataset.cur = src;
el.classList.remove('is-playing');
v.src = src;
}
const pr = v.play();
if (pr && pr.catch) pr.catch(() => {});
} else if (!v.paused) v.pause();
}
if (f.weather) f.weather.active(run);
if (f.toggle) {
f.toggle.textContent = f.paused ? 'Play' : 'Pause';
f.toggle.setAttribute('aria-label', f.paused ? 'Play the background video' : 'Pause the background video');
f.toggle.classList.toggle('is-paused', f.paused);
}
};
if (f.toggle) {
f.toggle.addEventListener('click', () => {
f.paused = !f.paused;
f.sync();
});
}
films.push(f);
if (io) io.observe(el);
f.sync();
});
$$('canvas[data-weather]', scope).forEach((cv) => {
if (cv.closest('[data-film]') || cv.__va) return;
cv.__va = true;
const api = makeWeather(cv);
if (!api) return;
watchSize(api);
if ('IntersectionObserver' in w) {
new IntersectionObserver((entries) => entries.forEach((e) => api.active(e.isIntersecting && !d.hidden)), { rootMargin: '80px 0px' }).observe(cv);
} else api.active(true);
});
};
const syncAll = () => films.forEach((f) => f.sync());
d.addEventListener('visibilitychange', () => {
syncAll();
if (d.hidden) weathers.forEach((x) => x.active(false));
});
if (small.addEventListener) small.addEventListener('change', syncAll);
const setAnn = () => {
const a = $('.va-announce');
d.documentElement.style.setProperty('--ann-h', `${a ? a.getBoundingClientRect().height : 0}px`);
};
setAnn();
w.addEventListener('resize', setAnn);
const openHero = (hero) => {
if (!hero || hero.__va) return;
hero.__va = true;
const img = $('.va-film__still img', hero);
let done = false;
const go = () => {
if (done) return;
done = true;
requestAnimationFrame(() => requestAnimationFrame(() => hero.classList.add('is-loaded')));
};
if (!img || img.complete) go();
else {
img.addEventListener('load', go, { once: true });
img.addEventListener('error', go, { once: true });
setTimeout(go, 1600);
}
};
const hero = $('[data-hero]');
openHero(hero);
initFilms(d);
d.addEventListener('shopify:section:load', (e) => {
const h = $('[data-hero]', e.target);
if (h) h.classList.add('is-loaded');
initFilms(e.target);
});
d.addEventListener('shopify:section:unload', (e) => {
weathers.forEach((x) => e.target.contains(x.canvas) && x.active(false));
});
const menu = $('[data-menu]');
if (menu) menu.inert = true;
const setMenu = (open) => {
if (!menu) return;
menu.classList.toggle('is-open', open);
menu.inert = !open;
menu.setAttribute('aria-hidden', String(!open));
$$('[data-menu-toggle]').forEach((b) => b.setAttribute('aria-expanded', String(open)));
d.documentElement.style.overflow = open ? 'hidden' : '';
if (open) {
const first = $('.va-menu__links a', menu);
if (first) setTimeout(() => first.focus(), 120);
} else {
const opener = $('.va-header [data-menu-toggle]');
if (opener) opener.focus();
}
};
const drawer = () => $('[data-drawer]');
let lastFocus = null;
if (drawer()) drawer().inert = true;
const openDrawer = () => {
const dr = drawer();
if (!dr) return false;
if (!dr.classList.contains('is-open')) lastFocus = d.activeElement;
dr.classList.add('is-open');
dr.inert = false;
dr.setAttribute('aria-hidden', 'false');
d.documentElement.style.overflow = 'hidden';
setTimeout(() => {
const p = $('.va-drawer__panel', dr);
if (p) p.focus();
}, 60);
return true;
};
const closeDrawer = () => {
const dr = drawer();
if (!dr || !dr.classList.contains('is-open')) return;
dr.classList.remove('is-open');
dr.inert = true;
$$('.va-moment', dr).forEach((m) => m.remove());
dr.setAttribute('aria-hidden', 'true');
d.documentElement.style.overflow = '';
if (lastFocus && lastFocus.focus) lastFocus.focus();
};
const bump = (count) => {
$$('[data-cart-count]').forEach((el) => {
el.textContent = count;
el.classList.remove('is-bump');
void el.offsetWidth;
el.classList.add('is-bump');
});
};
const applyDrawer = (html) => {
if (!html) return;
const doc = new DOMParser().parseFromString(html, 'text/html');
const fresh = $('[data-drawer-inner]', doc);
const cur = $('[data-drawer-inner]');
if (fresh && cur) cur.replaceWith(fresh);
if (fresh) bump(fresh.getAttribute('data-count'));
};
const post = (url, body) =>
fetch(root + url, {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify(body)
}).then(async (r) => {
const j = await r.json().catch(() => ({}));
if (!r.ok) throw j;
return j;
});
d.addEventListener('click', (e) => {
const t = e.target;
const menuToggle = t.closest('[data-menu-toggle]');
if (menuToggle) {
e.preventDefault();
setMenu(!(menu && menu.classList.contains('is-open')));
return;
}
if (t.closest('[data-drawer-open]')) {
if (d.body.classList.contains('t-cart')) return;
if (menu && menu.classList.contains('is-open')) setMenu(false);
if (openDrawer()) e.preventDefault();
return;
}
if (t.closest('[data-drawer-close]')) {
e.preventDefault();
closeDrawer();
return;
}
const lineBtn = t.closest('[data-line]');
if (lineBtn) {
e.preventDefault();
const inDrawer = !!lineBtn.closest('[data-drawer]');
const dr = drawer();
if (dr) dr.classList.add('is-busy');
post('cart/change.js', {
line: Number(lineBtn.dataset.line),
quantity: Number(lineBtn.dataset.qty),
sections: SECTION,
sections_url: w.location.pathname
})
.then((res) => {
if (!inDrawer) {
w.location.reload();
return;
}
applyDrawer(res.sections && res.sections[SECTION]);
})
.catch(() => w.location.reload())
.finally(() => {
if (dr) dr.classList.remove('is-busy');
});
return;
}
const thumb = t.closest('[data-thumb]');
if (thumb) {
const stage = thumb.closest('[data-stage]');
const img = stage && $('[data-stage-img]', stage);
if (img) {
img.srcset = thumb.dataset.srcset || '';
img.src = thumb.dataset.src;
img.alt = thumb.dataset.alt || '';
}
if (stage) $$('[data-thumb]', stage).forEach((x) => x.setAttribute('aria-current', String(x === thumb)));
return;
}
const peek = t.closest('[data-box-peek]');
if (peek) {
const stage = peek.closest('[data-vault-stage]') || d;
const box = $('[data-box]', stage);
const msg = $('[data-box-secret]', stage);
if (!box || box.classList.contains('is-open')) return;
box.classList.add('is-open');
if (msg) msg.textContent = msg.dataset.text || '';
setTimeout(() => {
box.classList.remove('is-open');
if (msg) setTimeout(() => (msg.textContent = ''), 600);
}, 3000);
}
});
d.addEventListener('keydown', (e) => {
if (e.key !== 'Escape') return;
closeDrawer();
if (menu && menu.classList.contains('is-open')) setMenu(false);
});
let momentCopy = null;
const copy = () => {
if (momentCopy) return momentCopy;
try {
momentCopy = JSON.parse(($('script[data-moment-copy]') || {}).textContent || '{}');
} catch (_) {
momentCopy = {};
}
return momentCopy;
};
const fillCopy = (t, it, price) =>
String(t || '')
.replace(/\[title\]/g, it.product_title || '')
.replace(/\[price\]/g, price || '');
const celebrate = (it) => {
const body = $('[data-drawer] .va-drawer__body');
if (!body || !it) return;
const c = copy();
const opts = it.options_with_values || [];
const pyp = opts.find((o) => o.name === (c.pyp_option || 'Your price'));
let title = c.bottle;
let sub = pyp ? c.pyp_sub : c.bottle_sub;
if (it.product_type === 'Mystery Box') {
title = c.box;
sub = c.box_sub;
} else if (it.product_type === 'Sample') {
title = c.sample;
sub = c.sample_sub;
}
if (!title) return;
const el = d.createElement('div');
el.className = 'va-moment';
el.setAttribute('role', 'status');
const src = it.image || (it.featured_image && it.featured_image.url);
if (src) {
const img = d.createElement('img');
img.className = 'va-moment__img';
img.alt = '';
img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=240';
el.appendChild(img);
} else {
const seal = d.createElement('span');
seal.className = 'va-seal';
const mark = $('.va-mark');
if (mark) {
const m = mark.cloneNode(true);
m.setAttribute('class', 'va-mark');
seal.appendChild(m);
}
el.appendChild(seal);
}
const txt = d.createElement('div');
const h = d.createElement('p');
h.className = 'va-moment__title';
h.textContent = fillCopy(title, it, pyp && pyp.value);
txt.appendChild(h);
if (sub) {
const p = d.createElement('p');
p.className = 'va-moment__sub';
p.textContent = fillCopy(sub, it, pyp && pyp.value);
txt.appendChild(p);
}
el.appendChild(txt);
if (!reduce.matches) {
const dust = d.createElement('span');
dust.className = 'va-moment__dust';
dust.setAttribute('aria-hidden', 'true');
for (let i = 0; i < 12; i++) {
const g = d.createElement('i');
g.style.left = rand(4, 96).toFixed(1) + '%';
g.style.animationDelay = rand(0.05, 0.9).toFixed(2) + 's';
g.style.setProperty('--dx', rand(-26, 26).toFixed(0) + 'px');
dust.appendChild(g);
}
el.appendChild(dust);
}
$$('.va-moment', body).forEach((m) => m.remove());
body.prepend(el);
body.scrollTop = 0;
requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-in')));
};
d.addEventListener('submit', (e) => {
const form = e.target.closest('form[data-checkout-form]');
const tpl = $('#va-seal-tpl');
if (!form || !tpl || e.defaultPrevented || reduce.matches) return;
e.preventDefault();
const node = tpl.content.firstElementChild.cloneNode(true);
d.body.appendChild(node);
requestAnimationFrame(() => requestAnimationFrame(() => node.classList.add('is-on')));
let gone = false;
const go = () => {
if (gone) return;
gone = true;
const h = d.createElement('input');
h.type = 'hidden';
h.name = 'checkout';
h.value = '1';
form.appendChild(h);
HTMLFormElement.prototype.submit.call(form);
};
node.addEventListener('click', go);
d.addEventListener('keydown', go, { once: true });
setTimeout(go, 1650);
});
d.addEventListener('submit', (e) => {
const form = e.target.closest('form[data-product-form]');
if (!form || !drawer()) return;
e.preventDefault();
const buttons = $$('[type=submit]', form).concat(form.id ? $$('[form]').filter((b) => b.getAttribute('form') === form.id) : []);
const err = $('[data-form-error]', form);
if (err) {
err.hidden = true;
err.textContent = '';
}
buttons.forEach((b) => b.classList.add('is-busy'));
const fd = new FormData(form);
const item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
const props = {};
for (const [k, v] of fd.entries()) {
if (k.indexOf('properties[') !== 0 || k.slice(-1) !== ']') continue;
const key = k.slice(11, -1);
if (key && String(v).trim()) props[key] = String(v).trim();
}
if (Object.keys(props).length) item.properties = props;
post('cart/add.js', { items: [item], sections: SECTION, sections_url: w.location.pathname })
.then((res) => {
applyDrawer(res.sections && res.sections[SECTION]);
openDrawer();
celebrate(res.items && res.items[0]);
})
.catch((j) => {
if (err) {
err.textContent = j.description || j.message || 'This item could not be added. Try again.';
err.hidden = false;
}
})
.finally(() => buttons.forEach((b) => b.classList.remove('is-busy')));
});
const initBuy = (scope) => {
$$('[data-product]', scope).forEach((wrap) => {
const src = $('script[data-variants]', wrap);
const form = $('form[data-product-form]', wrap);
const idInput = form && $('input[name=id]', form);
const sets = $$('[data-option]', wrap);
if (!src || !idInput || !sets.length) return;
let variants = [];
try {
variants = JSON.parse(src.textContent);
} catch (_) {
return;
}
const host = wrap.closest('.shopify-section') || wrap;
let urlTimer = 0;
const update = () => {
const chosen = sets.map((fs) => {
const c = $('input:checked', fs);
return c ? c.value : null;
});
const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
const adds = $$('[data-add]', host);
if (!v) {
adds.forEach((b) => {
b.disabled = true;
b.textContent = 'Unavailable';
});
return;
}
idInput.value = v.id;
$$('[data-price]', host).forEach((el) => (el.textContent = v.price));
$$('[data-compare]', host).forEach((el) => {
el.textContent = v.compare || '';
el.hidden = !v.compare;
});
adds.forEach((b) => {
b.disabled = !v.available;
b.textContent = v.available ? 'Add to bag' : 'Sold out';
});
clearTimeout(urlTimer);
urlTimer = setTimeout(() => {
try {
const u = new URL(w.location.href);
u.searchParams.set('variant', v.id);
w.history.replaceState(w.history.state, '', u.toString());
} catch (_) {}
}, 300);
};
sets.forEach((fs) => fs.addEventListener('change', update));
});
$$('[data-pyp]', scope).forEach((fs) => {
const range = $('[data-pyp-range]', fs);
const radios = $$('input[type=radio]', fs);
if (!range || !radios.length) return;
const last = Math.max(radios.length - 1, 1);
const paint = (i) => {
fs.style.setProperty('--pyp', (i / last).toFixed(4));
if (radios[i]) range.setAttribute('aria-valuetext', radios[i].value);
};
const pick = () => {
const i = Math.min(Math.max(Math.round(Number(range.value) || 0), 0), radios.length - 1);
paint(i);
const r = radios[i];
if (r.checked) return;
r.checked = true;
r.dispatchEvent(new Event('change', { bubbles: true }));
};
const seal = $('[data-seal]', fs.closest('form') || fs);
const stamp = () => {
if (!seal || reduce.matches) return;
seal.classList.remove('is-stamp');
void seal.offsetWidth;
seal.classList.add('is-stamp');
};
range.addEventListener('input', pick);
range.addEventListener('change', () => {
pick();
stamp();
});
const start = radios.findIndex((r) => r.checked);
if (start > -1 && String(start) !== range.value) range.value = String(start);
paint(Math.max(start, 0));
});
};
initBuy(d);
d.addEventListener('shopify:section:load', (e) => initBuy(e.target));
const stickyBar = $('[data-stickybar]');
const stickyAnchor = $('[data-sticky-anchor]');
if (stickyBar) stickyBar.inert = true;
const updateSticky = () => {
if (!stickyBar || !stickyAnchor) return;
const show = stickyAnchor.getBoundingClientRect().bottom < 0;
if (show === stickyBar.classList.contains('is-shown')) return;
stickyBar.classList.toggle('is-shown', show);
stickyBar.inert = !show;
stickyBar.setAttribute('aria-hidden', String(!show));
};
const dry = $('[data-dry]');
const dryNotes = [];
let dryTrack = null;
let dryTime = null;
let dryBar = null;
let dryPhases = [];
let lastLabel = '';
const fmt = (min) => {
if (min < 1) return 'Just sprayed';
if (min < 60) return `${Math.round(min)} min`;
const h = min / 60;
const hh = h < 3 ? Math.round(h * 2) / 2 : Math.round(h);
return hh === 1 ? '1 hour' : `${hh} hours`;
};
const initDry = () => {
if (!dry || reduce.matches) return;
dry.classList.add('is-live');
dryTrack = $('.va-dry__track', dry);
dryTime = $('[data-dry-time]', dry);
dryBar = $('[data-dry-bar]', dry);
dryPhases = $$('[data-phase]', dry);
$$('[data-tier]', dry).forEach((tier) => {
const kind = tier.dataset.tier;
const notes = $$('.va-note', tier);
const n = Math.max(notes.length, 1);
notes.forEach((el, i) => dryNotes.push({ el, kind, k: i / n }));
});
};
const updateDry = () => {
if (!dryTrack) return;
const r = dryTrack.getBoundingClientRect();
if (r.bottom < -50 || r.top > w.innerHeight + 50) return;
const total = r.height - (w.innerHeight - (parseFloat(getComputedStyle(d.documentElement).getPropertyValue('--hdr-h')) || 0));
const p = clamp(-r.top / (total > 0 ? total : 1), 0, 1);
const minutes = 480 * p * p;
const label = fmt(minutes);
if (dryTime && label !== lastLabel) {
dryTime.textContent = label;
lastLabel = label;
}
if (dryBar) dryBar.style.setProperty('--p', p.toFixed(4));
const phase = minutes < 15 ? 0 : minutes < 180 ? 1 : 2;
dryPhases.forEach((li, i) => li.classList.toggle('is-on', i === phase));
for (const n of dryNotes) {
let v = 1;
let y = 0;
let op = 1;
if (n.kind === 'top') {
const s = 0.04 + 0.18 * n.k;
v = 1 - smooth(s, s + 0.16, p);
y = -(1 - v) * 70;
op = v;
} else if (n.kind === 'heart') {
const a = 0.04 + 0.08 * n.k;
const b = 0.5 + 0.12 * n.k;
const fade = smooth(b, b + 0.2, p);
v = clamp(0.22 + 0.78 * smooth(a, a + 0.12, p) - 0.55 * fade, 0, 1);
y = -fade * 26;
op = 0.1 + 0.9 * v;
} else {
const c = 0.3 + 0.14 * n.k;
const bloom = smooth(c, c + 0.2, p);
v = 0.14 + 0.86 * bloom;
y = -(1 - bloom) * 14;
op = 0.1 + 0.9 * v;
}
n.el.style.opacity = op.toFixed(3);
n.el.style.filter = v > 0.985 ? 'none' : `blur(${((1 - v) * 8).toFixed(2)}px)`;
n.el.style.transform = `translate3d(0,${y.toFixed(1)}px,0)`;
}
};
initDry();
$$('[data-colonnade]').forEach((c) => {
const track = $('[data-track]', c);
const prev = $('[data-prev]', c);
const next = $('[data-next]', c);
if (!track) return;
const step = () => {
const first = track.firstElementChild;
const gap = parseFloat(getComputedStyle(track).columnGap) || 24;
return first ? first.getBoundingClientRect().width + gap : 300;
};
const sync = () => {
if (prev) prev.disabled = track.scrollLeft < 4;
if (next) next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 4;
};
if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduce.matches ? 'auto' : 'smooth' }));
if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduce.matches ? 'auto' : 'smooth' }));
track.addEventListener('scroll', sync, { passive: true });
w.addEventListener('resize', sync);
sync();
});
$$('[data-sort]').forEach((sel) =>
sel.addEventListener('change', () => {
const u = new URL(w.location.href);
u.searchParams.set('sort_by', sel.value);
u.searchParams.delete('page');
w.location.href = u.toString();
})
);
const header = $('[data-header]');
let ticking = false;
const frame = () => {
ticking = false;
if (header) header.classList.toggle('is-scrolled', w.scrollY > 8);
if (hero && !reduce.matches) {
const r = hero.getBoundingClientRect();
if (r.bottom > -40) hero.style.setProperty('--hp', clamp(-r.top / (r.height || 1), 0, 1).toFixed(3));
}
updateSticky();
updateDry();
};
const onScroll = () => {
if (ticking) return;
ticking = true;
requestAnimationFrame(frame);
};
w.addEventListener('scroll', onScroll, { passive: true });
w.addEventListener('resize', onScroll);
frame();
const finePointer = w.matchMedia('(hover: hover) and (pointer: fine)');
if (d.body.hasAttribute('data-cursor') && finePointer.matches && !(w.Shopify && w.Shopify.designMode)) {
const html = d.documentElement;
const make = (cls) => {
const el = d.createElement('div');
el.className = cls;
el.setAttribute('aria-hidden', 'true');
el.appendChild(d.createElement('i'));
d.body.appendChild(el);
return el;
};
const ring = make('va-cursor-ring');
const dot = make('va-cursor-dot');
const HOT = 'a[href],button,[role="button"],label,select,summary,input[type="range"],input[type="radio"],input[type="checkbox"],input[type="submit"],input[type="button"],.va-card,[data-thumb]';
const TEXT = 'input:not([type="range"]):not([type="radio"]):not([type="checkbox"]):not([type="submit"]):not([type="button"]):not([type="hidden"]),textarea,[contenteditable="true"],iframe';
let px = 0;
let py = 0;
let rx = 0;
let ry = 0;
let cursorRaf = 0;
let cursorLast = 0;
let cursorOn = false;
const place = (el, x, y) => {
el.style.transform = `translate3d(${x}px,${y}px,0)`;
};
const trail = (now) => {
const dt = Math.min(0.05, (now - cursorLast) / 1000 || 0.016);
cursorLast = now;
const k = reduce.matches ? 1 : 1 - Math.exp(-dt * 16);
rx += (px - rx) * k;
ry += (py - ry) * k;
if (Math.abs(px - rx) + Math.abs(py - ry) < 0.2) {
rx = px;
ry = py;
cursorRaf = 0;
} else cursorRaf = requestAnimationFrame(trail);
place(ring, rx, ry);
};
const away = (v) => html.classList.toggle('va-cursor-away', v);
d.addEventListener('pointermove', (e) => {
if (e.pointerType !== 'mouse') return;
px = e.clientX;
py = e.clientY;
if (!cursorOn) {
cursorOn = true;
rx = px;
ry = py;
place(ring, px, py);
html.classList.add('va-cursor-on');
}
place(dot, px, py);
away(false);
if (!cursorRaf) {
cursorLast = performance.now();
cursorRaf = requestAnimationFrame(trail);
}
}, { passive: true });
d.addEventListener('pointerover', (e) => {
const t = e.target;
if (!t || !t.closest) return;
const text = t.closest(TEXT);
const hot = text ? null : t.closest(HOT);
html.classList.toggle('va-cursor-text', !!text);
html.classList.toggle('va-cursor-hot', !!hot && !hot.disabled && hot.getAttribute('aria-disabled') !== 'true');
});
d.addEventListener('pointerout', (e) => {
if (!e.relatedTarget) away(true);
});
w.addEventListener('blur', () => away(true));
d.addEventListener('pointerdown', (e) => {
if (e.pointerType === 'mouse') {
html.classList.add('va-cursor-down');
return;
}
cursorOn = false;
html.classList.remove('va-cursor-on');
});
d.addEventListener('pointerup', () => html.classList.remove('va-cursor-down'));
}
w.addEventListener('pageshow', (e) => {
$$('.va-sealing').forEach((n) => n.remove());
if (!e.persisted) return;
fetch(root + 'cart.js')
.then((r) => r.json())
.then((c) => $$('[data-cart-count]').forEach((el) => (el.textContent = c.item_count)))
.catch(() => {});
syncAll();
});
})();
